import { FC } from "react";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../types/vdp";
import VehicleContainer from "../../common-components/vehicle-container/vehicle-container-loader";
import { Vehicle } from "../../../types/vehicle";
import { getTranslationModule } from "../../../utils/translations";

const SimilarVehicles: FC<IVDPPageBlock> = ({ config, siteData, pageContext, vdpGlobalData, translations }) => {
  const t = getTranslationModule(translations, "vdp");
  const vehicles: Vehicle[] = config;
  const vehicleCardData = vdpGlobalData.vehicleCardData;
  const vehicle = vdpGlobalData.vehicle;

  return (
    <VehicleContainer
      siteData={siteData}
      vehicles={vehicles}
      title={t("vehicles_you_may_like")}
      subtitle={`${vehicle.make} ${vehicle.model} ${vehicle.trim}`}
      pageContext={pageContext}
      vehicleCardConfig={vehicleCardData!}
      translations={translations}
      showTabs
    />
  );
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <SimilarVehicles
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.BOTTOM,
};

export default VDPBlockData;
